import React, { FC } from 'react'
import { Form } from '@ucheba/ui/components/Form/desktop'
import { InlineForm } from '@ucheba/ui/components/InlineForm/desktop'
import { TextField } from '@ucheba/ui/components/TextField/desktop'
import { Field, Formik } from 'formik'
import { IProgramsPageSearch } from '../types'

const ProgramsPageSearch: FC<IProgramsPageSearch> = (props) => {
  const { onSubmit } = props

  const field = <Field as={TextField} type='text' name='query' label='Поиск' />

  return (
    <div>
      <Formik
        initialValues={{ query: '' }}
        onSubmit={(values) => {
          onSubmit('query')(values.query)
        }}
        enableReinitialize
      >
        <Form fillByQuery>
          <InlineForm buttonText='Найти' control={field} />
        </Form>
      </Formik>
    </div>
  )
}

export default ProgramsPageSearch
